import { SET_UPCOMING_TRANS_STATE } from '../types'
export default (state = false, action) => {
  switch (action.type) {
    case SET_UPCOMING_TRANS_STATE:
      return action.payload
    default:
      return state;
  }
}